import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import ContentLoader from '@adsk/alloy-react-content-loader';
const TemplateRowLoaderItem = () => /*#__PURE__*/React.createElement(ContentLoader, {
  width: 285,
  height: 50,
  viewBox: "0 0 285 50"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "17",
  rx: "3",
  ry: "3",
  width: "120",
  height: "6"
}), /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "30",
  rx: "3",
  ry: "3",
  width: "180",
  height: "6"
}));
const TemplateRowLoader = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledDiv, {
  "data-testid": "TemplateRowLoader",
  $_css: [{
    display: 'flex',
    alignItems: 'center',
    height: 60,
    padding: '8px 16px'
  }]
}, /*#__PURE__*/React.createElement(TemplateRowLoaderItem, null)), /*#__PURE__*/React.createElement(_StyledDiv2, {
  $_css2: [{
    display: 'flex',
    alignItems: 'center',
    height: 60,
    padding: '8px 16px'
  }]
}, /*#__PURE__*/React.createElement(TemplateRowLoaderItem, null)), /*#__PURE__*/React.createElement(_StyledDiv3, {
  $_css3: [{
    display: 'flex',
    alignItems: 'center',
    height: 60,
    padding: '8px 16px'
  }]
}, /*#__PURE__*/React.createElement(TemplateRowLoaderItem, null)));
TemplateRowLoader.displayName = 'TemplateRowLoader';
export default TemplateRowLoader;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "TemplateRowLoader___StyledDiv3",
  componentId: "sc-1sw6fl5-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=TemplateRowLoader.js.map